var React = require('react');

function SendPrimary3 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M44.0039 3.99805L22.0039 25.998","stroke":"#14AA69","strokeWidth":"4","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M44.0039 3.99805L30.0039 43.9981L22.0039 25.998L4.00391 17.998L44.0039 3.99805Z","stroke":"#14AA69","strokeWidth":"4","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

SendPrimary3.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = SendPrimary3;

SendPrimary3.default = SendPrimary3;
